// removed by extract-text-webpack-plugin
module.exports = {"project":"Project-cssmodule-project-H1tAT","title":"Project-cssmodule-title-3wCjW","badge":"Project-cssmodule-badge-21dVt","titleText":"Project-cssmodule-titleText-1u7um","contentView":"Project-cssmodule-contentView-2mS-o","content":"Project-cssmodule-content-SrBgA","media":"Project-cssmodule-media-3pZHt","buttonView":"Project-cssmodule-buttonView-3qzQ4","button":"Project-cssmodule-button-8ab5I"};


//////////////////
// WEBPACK FOOTER
// ./components/ModalSet/Project.cssmodule.less
// module id = 663
// module chunks = 0